import React, {useEffect, useState} from 'react';
import { OperationsPopUpProps, Options } from '../../types/operations';
import PopUp from '../../components/PopUp';
import { Select} from '@mantine/core';
import {ReactComponent as DropdownIcon } from '../../assets/icons/Dropdown.svg'
import { DateTimePicker } from '@mantine/dates';
import { useRecipes } from '../../context/RecipeContext';
import { useSorters } from '../../context/SorterContext';


const OperationsPopUp = ({opened, close, title, onSave}:OperationsPopUpProps)=>{
    const [SorterValue, setSorterValue] = useState<string | null>(null);
    const [RecipeValue, setRecipeValue] = useState<string | null>(null);
    const [BeltValue, setBeltValue] = useState<string |null>(null);
    const [time, setTime] = useState<string | null>(null);
    const [inputError, setInputError] = useState('');


    const {recipes} = useRecipes();
    const {sorters} = useSorters();
   
    const uniqueSorters = Array.from(
        new Map(sorters.map(s => [`${s.id}|${s.name}`, s])).values()
    );
    const sorterOptions = uniqueSorters.map((sorter)=>({value: String(sorter.id), label: sorter.name}))
    

    const [beltOptions, setBeltOptions] = useState<Options[]>([])
     useEffect( ()=>{
        const sorterBelts = sorters.filter((sorter)=> sorter.id === Number(SorterValue));
        const uniqueBelts = Array.from(
            new Map(sorterBelts.map(b => [b.beltId, b])).values()
        );
        setBeltOptions(uniqueBelts.map((belt)=>({value: String(belt.beltId), label: belt.beltName})));
    } , [SorterValue, sorters])


    const [recipeOptions, setRecipeOptions] = useState<Options[]>([]);
    useEffect( ()=>{
        const sorterFiltered = sorters.filter(sorter => sorter.beltId === Number(BeltValue)).map(s => Number(s.num_hoppers));
        setRecipeOptions(recipes.filter((recipe)=> sorterFiltered.includes(recipe.num_hoppers)).map((recipe)=>({value: String(recipe.id), label: recipe.name})));
    } , [BeltValue, recipes])


 
    const isFutureOrNow = (value:string | null) => {
        if (typeof value === 'string') {
            const parsedDate = new Date(value.replace(' ', 'T'));
            return parsedDate >= new Date(); 
        }

        return false; 
        };

    const handleChange = (value: string|null) => {
        setTime(value);

        if (!isFutureOrNow(value)){
            setInputError('Start date must be now or in the future.');
        }else {
            setInputError('');
        }
            
    };

    const onClickSave = () =>{
        onSave(Number(SorterValue), Number(BeltValue), Number(RecipeValue), time, 1)
        close()
    }

    return(
        <PopUp opened={opened} close={close} title={title} onSave={onClickSave} >
            <Select label={"Sorter"} data={sorterOptions} value={SorterValue} onChange={setSorterValue} rightSection={<DropdownIcon  width={19} height={19}></DropdownIcon >}/>
            <Select label={"Belt"} data={beltOptions} value={BeltValue} onChange={setBeltValue} rightSection={<DropdownIcon  width={19} height={19}></DropdownIcon >}/>
            <Select label={"Recipe"} data={recipeOptions} value={RecipeValue} onChange={setRecipeValue} rightSection={<DropdownIcon  width={19} height={19}></DropdownIcon >}/>
            <DateTimePicker label="Start Time" placeholder="" error={inputError} value={time} onChange={handleChange} /> 
        </PopUp>    
    );
    
}

export default OperationsPopUp